import { createSelector } from 'reselect';
 
export const selectFetchingEntities = state => state.data.fetchingEntities;
export const selectEntities = state => state.data.entities;
export const selectGroupingLevels = state => state.data.groupingLevels;
export const selectFetchingGroupingLevels = state =>state.data.groupingLevelsFetching;

export const selectGetGroupingLevel = createSelector(
  selectGroupingLevels,
  groupingLevels => {
    const groupingLevelsByLevelValue = groupingLevels.reduce((map, level) => {
      map[level.id] = level;
      return map;
    }, {});

    return levelValue => groupingLevelsByLevelValue[levelValue];
  }
);
